import { render, staticRenderFns } from "./PrintSocialVisits.vue?vue&type=template&id=48fd0c2e&"
import script from "./PrintSocialVisits.vue?vue&type=script&lang=js&"
export * from "./PrintSocialVisits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports